// extracted by mini-css-extract-plugin
export default {"applePayBanner":"styles_applePayBanner__gzAJI","description":"styles_description__+f5AC","close":"styles_close__OzcsG"};